import React from 'react';
import { TooltipStyled } from '../../asset/styled/component/TooltipStyled';

const Tooltip = ({ children, message, visible }) => {
  return (
    <TooltipStyled>
      {children}
      {visible && (
        <div className="tooltip-container">
          <div className="tooltip-arrow" />
          <div className="tooltip-content captionMedium">{message}</div>
        </div>
      )}
    </TooltipStyled>
  );
};

export default Tooltip;
